module.exports = __webpack_public_path__ + "frontend/images/favicons/favicon-16x16.png?d3d0e72ea07c5048ba1fc084df1c4613";